module.exports = __webpack_public_path__ + "static/img/Glovo.d9b17d7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Glovo.png
// module id = tU6x
// module chunks = 4